import { createContext } from 'react';

export const MentorProfileContext = createContext(null)